/**
 * Test IDs for QA automation.
 */
export const testIds = {
  trailerInputAutocomplete: "trailer-input-autocomplete",
  trailerInputAutocompleteInput: "trailer-input-autocomplete-input",
  trailerInputAutocompleteOption: "trailer-input-autocomplete-option",
  trailerInputAutocompleteTag: "trailer-input-autocomplete-tag",
} as const;
